import { types } from 'mobx-state-tree';

const _participant = types.model('Participant', {
    name: types.maybe(types.string),
    avatar: types.maybe(types.string), 
    avatarColor: types.maybe(types.string)
});

export const Interaction = types.model('Interaction', {
    duration: types.maybe(types.integer), 
    text: types.maybe(types.string), 
    startTime: types.maybe(types.number),
    participantName: types.maybe(types.string)
});

// Q&A Practice question model
const _question = types.model('Question', {
    index: types.maybe(types.integer),
    rephrasedQuestion: types.maybe(types.string),
    participantName: types.maybe(types.string),
    relatedTo: types.maybeNull(types.string)
});

const _meeting = types.model('Meeting', {
    interactions: types.optional(types.array(Interaction), []),
    participants: types.optional(types.array(_participant), []),
    meetingTypeKey: types.optional(types.string, ''),
    level: types.optional(types.integer, 1),
    interactionId: types.optional(types.union(types.string, types.null), null),  // ID linking to interaction context in DynamoDB
    // Q&A Practice specific fields
    sessionId: types.optional(types.union(types.string, types.null), null),
    questions: types.optional(types.array(_question), []),
    questionCount: types.optional(types.integer, 0)
});

export const Meeting = types.compose(_meeting);